import axios from 'axios';

const BASE_URL = 'https://loyalty.bom.asia';
const API_BASE_URL = `${BASE_URL}/api/miniApp/quiz/alerts`;

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const alertApi = {
  // Get all alerts (Admin)
  getAllAlerts: async (params = {}) => {
    try {
      
      // Build query string
      const queryParams = new URLSearchParams();
      
      // Pagination
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      
      // Filters
      if (params.type) queryParams.append('type', params.type);
      if (params.isActive !== undefined) queryParams.append('isActive', params.isActive);
      
      const queryString = queryParams.toString();
      const url = queryString ? `/admin?${queryString}` : '/admin';
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('❌ Error getting all alerts:', error);
      throw error;
    }
  },

  // Get single alert by ID
  getAlertById: async (id) => {
    try {
      const response = await api.get(`/admin/${id}`);
      return response.data;
    } catch (error) {
      console.error('❌ Error getting alert by ID:', error);
      throw error;
    }
  },

  // Create new alert
  createAlert: async (alertData) => {
    try {
      const response = await api.post('/admin', alertData);
      return response.data;
    } catch (error) {
      console.error('❌ Error creating alert:', error);
      throw error;
    }
  },

  // Create multiple alerts (bulk)
  createAlertsBulk: async (alertsArray) => {
    try {
      const response = await api.post('/admin/bulk', alertsArray);
      return response.data;
    } catch (error) {
      console.error('❌ Error creating alerts in bulk:', error);
      throw error;
    }
  },

  // Update alert
  updateAlert: async (id, updateData) => {
    try {
      const response = await api.put(`/admin/${id}`, updateData);
      return response.data;
    } catch (error) {
      console.error('❌ Error updating alert:', error);
      throw error;
    }
  },

  // Delete alert
  deleteAlert: async (id) => {
    try {
      const response = await api.delete(`/admin/${id}`);
      return response.data;
    } catch (error) {
      console.error('❌ Error deleting alert:', error);
      throw error;
    }
  },

  // Toggle alert active status
  toggleAlertStatus: async (id, isActive) => {
    try {
      const response = await api.put(`/admin/${id}`, { isActive });
      return response.data;
    } catch (error) {
      console.error('❌ Error toggling alert status:', error);
      throw error;
    }
  },

  // Get alerts by type
  getAlertsByType: async (type) => {
    try {
      const response = await api.get(`/admin?type=${type}`);
      return response.data;
    } catch (error) {
      console.error('❌ Error getting alerts by type:', error);
      throw error;
    }
  },

  // Get active alerts only
  getActiveAlerts: async () => {
    try {
      const response = await api.get('/admin?isActive=true');
      return response.data;
    } catch (error) {
      console.error('❌ Error getting active alerts:', error);
      throw error;
    }
  }
};

export default alertApi;

